const Globals = {
    document: () => document,
};

/**
 * create a cookie with all the needed Parameters
 * @param cookieName
 * @param cookieValue
 * @param lifeTimeInDays
 */
const create = ({ cookieName, cookieValue, lifeTimeInDays = 30 }) => {
    const cookieMaxAgeInSecunds = lifeTimeInDays * 86400; //24h * 60m * 60s
    const samesite = 'lax';
    Globals.document().cookie =
        cookieName + '=' + cookieValue + ';max-age=' + cookieMaxAgeInSecunds + ';path=/;secure; samesite=' + samesite;
};
const Cookie = {
    create,
};

let _isHudu = true;
const configure = (isHudu) => {
    _isHudu = isHudu;
};
/**
 * Write an emarsys Cookie for later use in GTM Tags
 */
const loggedInCustomer = ({ hashId, myshopFlag }) => {
    const cookieName = _isHudu ? 'ems_hd_id' : 'ems_eb_id';
    const cookieValue = myshopFlag ? hashId : 'dummy@example.com';
    const cookieparameter = { cookieName, cookieValue };
    Cookie.create(cookieparameter);
};
const Emarsys = {
    configure,
    loggedInCustomer,
};

export { Emarsys };
